import { INVALIDATE as AUTH_INVALIDATE } from '@/store/actions/auth';
import {
    SET_MOBILE_MENU,
    SET_IS_CREATE_MODAL_SHOWING
} from '@/store/actions/app';

const initialState = {
    mobileMenu: false,
    isCreateModalShowing: false
};

export default (state = initialState, action) => {
    switch (action.type) {
        case SET_MOBILE_MENU: {
            return { ...state, mobileMenu: action.data };
        }
        case SET_IS_CREATE_MODAL_SHOWING: {
            return { ...state, isCreateModalShowing: action.data };
        }
        case AUTH_INVALIDATE:
        default:
            return state;
    }
};
